import {ColumnMain} from "../column-main";
import {Column} from "../column";
import {Trans} from "@lingui/macro";
import React from "react";
import { Tag } from 'antd';

const MovementHistoryModel = () : ColumnMain => {

    const columns : Array<Column> = new Array();
    columns.push({key:'rollNumber', width: 200, fixed: "left",  filter:true, sorter:true,title:<Trans>Roll Num.</Trans>});
    columns.push({
        key: 'movement',
        width: 200,
        uniqueSelectFilterData: [
            {
                label: <Trans>All</Trans>,
                value: null,
            },
            {
                label: <Trans>RECEIVED</Trans>,
                value: 'RECEIVED',
            },
            {
                label: <Trans>RETURNED</Trans>,
                value: 'RETURNED',
            },
            {
                label: <Trans>STATUS_CHANGED</Trans>,
                value: 'STATUS_CHANGED',
            },
            {
                label: <Trans>LOCKED</Trans>,
                value: 'LOCKED',
            },
            {
                label: <Trans>STORED</Trans>,
                value: 'STORED',
            },
            {
                label: <Trans>UNLOCKED</Trans>,
                value: 'UNLOCKED',
            },
            {
                label: <Trans>TRANSFERRED</Trans>,
                value: 'TRANSFERRED',
            },
            {
                label: <Trans>DELIVERED</Trans>,
                value: 'DELIVERED',
            },
        ],
        sorter: true,
        title: <Trans>Movement</Trans>,
        render: text => {
            let color = 'gray';
            let transText;
            if (text === 'RECEIVED') {
                color = 'orange';
                transText = <Trans>RECEIVED</Trans>;
            } else if (text === 'RETURNED') {
                color = 'geekblue';
                transText = <Trans>RETURNED</Trans>;
            } else if (text === 'STATUS_CHANGED') {
                color = 'gold';
                transText = <Trans>STATUS_CHANGED</Trans>;
            } else if (text === 'LOCKED') {
                color = 'red';
                transText = <Trans>LOCKED</Trans>;
            } else if (text === 'STORED') {
                color = 'blue';
                transText = <Trans>STORED</Trans>;
            } else if (text === 'UNLOCKED') {
                color = 'yellow';
                transText = <Trans>UNLOCKED</Trans>;
            } else if (text === 'TRANSFERRED') {
                color = 'yellow';
                transText = <Trans>TRANSFERRED</Trans>;
            } else if (text === 'DELIVERED') {
                color = 'green';
                transText = <Trans>DELIVERED</Trans>;
            }
            return (
                <Tag color={color} key={text}>
                    {transText}
                </Tag>
            );
        },
    });

    columns.push({key:'comment', width: 500, filter:true, sorter:true,title:<Trans>Comment</Trans>});
    columns.push({key:'from', width: 200, filter:true, sorter:true,title:<Trans>From</Trans>});
    columns.push({key:'to', width: 200, filter:true, sorter:true,title:<Trans>To</Trans>});
    columns.push({key:'updatedDate', width: 150, dateFilter:true, sorter:true,title:<Trans>Updated Date</Trans>});
    columns.push({key:'updatedBy', width: 150, dateFilter:true, sorter:true,title:<Trans>Updated By</Trans>});
    columns.push({key:'createdDate', width: 150, dateFilter:true, sorter:true,title:<Trans>Created Date</Trans>,direction:"desc"});
    columns.push({key:'createdBy', width: 150, dateFilter:true, sorter:true,title:<Trans>Created By</Trans>});


    return{
        columns:columns,
        url:"/resource/movement-history"
    };

}
export default MovementHistoryModel();
